









import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class Avatar extends Vue {
  @Prop({ required: true }) image!: string;
  @Prop({ default: 50 }) width!: number;
  @Prop({ default: 50 }) height!: number;
}
